function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IndiaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#F7FCFF",
      fillRule: "evenodd",
      d: "M0 3v18h24V3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("mask", {
      id: "b",
      width: "24",
      height: "18",
      x: "0",
      y: "3",
      maskUnits: "userSpaceOnUse",
      style: {
        maskType: 'luminance'
      },
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 3v18h24V3H0Z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsxs("g", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      mask: "url(#b)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#FF8C1A",
        d: "M0 3v6h24V3H0Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#5EAA22",
        d: "M0 15v6h24v-6H0Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#3D58DB",
        d: "M9 12a3 3 0 1 0 6 0 3 3 0 0 0-6 0Zm5.25 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#3D58DB",
        d: "m11.996 12.646-.626 2.305.367-2.36-1.51 1.851 1.295-2.007-2.131 1.077 1.999-1.307-2.386.118 2.358-.381-2.227-.863 2.309.61L9.76 9.996l1.861 1.498-.849-2.233 1.091 2.125L11.996 9l.132 2.385L13.22 9.26l-.848 2.233 1.86-1.498-1.683 1.695 2.309-.611-2.227.863 2.358.38-2.386-.117 2 1.307-2.133-1.077 1.295 2.007-1.509-1.852.366 2.36-.625-2.304Z"
      })]
    })]
  })]
}));
//# sourceMappingURL=India.js.map